module.exports = __webpack_public_path__ + "img/x1.fcb554c2.jpg";